import { useSelector } from 'react-redux';

import { selectCategoryFamilyId } from '../selectors/categoryFamilyId';

export const useCategoryFamilyId = () =>
  useSelector(selectCategoryFamilyId)?.toString();
